"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.insertToCart = exports.getCustomerList = exports.baseList = exports.updateCarNum = exports.deleteCar = exports.carList = void 0;
const vue_1 = __importDefault(require("vue"));
const http = () => {
    return vue_1.default.prototype.$http;
};
// 购物车列表
exports.carList = (params) => __awaiter(void 0, void 0, void 0, function* () { return http().post('/customerCart/getList', params); });
// 删除购物车
exports.deleteCar = (params) => http().post('/customerCart/delete', params);
// 修改数量
exports.updateCarNum = (params) => http().post('/customerCart/modify', params);
// 码头列表
exports.baseList = (params) => http().post('/base/getList', params);
// 获取客户历史订单产品
exports.getCustomerList = (params) => http().post('/salescontracts/getCustomerList', params);
// 历史订单产品加入购物车
exports.insertToCart = (params) => http().post('/salescontracts/insertToCart', params);
